<div
	[formGroup]="formParams"
	class="zk-flex zk-flex-wrap zk-mb-4 zk-gap-4"
	*ngIf="formParams"
>
	<div class="zk-w-full" *ngIf="showTitle">
		<h1 class="zk-text-base text-color-2 zk-font-thick">
			{{ 'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.TITLE' | translate }}
		</h1>
	</div>
	<!--
	<div class="zk-w-full zk-flex" *ngIf="formParams.get('liveOutsideBrazil')">
		<input type="checkbox" class="zk-w-5 zk-h-5" formControlName="liveOutsideBrazil">
		<div class="text-color-2 zk-mt-1 zk-ml-5">{{'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.FOREIGN' | translate}}</div>
	</div>
	-->

	<div class="zk-w-full zk-flex zk-flex-wrap zk-gap-4 xl:zk-gap-0">
		<div class="zk-w-full xl:zk-w-6/12 xl:zk-pr-2">
			<zk-input class="sm:zk-mt-1" [zkStatus]="getPostalCodeStatus()">
				<input
					id="billing-postal-code"
					zkInputRef
					formControlName="postalCode"
					(input)="zipCodeChange($event)"
					(blur)="onZipCodeChange()"
					class="md:zk-pr-0"
					placeholder="{{ getLabelDescription('postal_code') }}"
				/>
				<span zkInputLabel>{{ getLabelDescription('postal_code') }} </span>
				<span
					zkInputMessage
					[class.zk-hidden]="!isFieldInvalid(formParams, 'postalCode')"
				>
					<ng-container *ngIf="!formParams.get('postalCode').value">
						{{
							'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.POSTAL_CODE'
								| translate
						}}
					</ng-container>
					<ng-container *ngIf="formParams.get('postalCode')?.value">
						{{
							'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.POSTAL_CODE_INVALID'
								| translate
						}}
					</ng-container>
				</span>
			</zk-input>
		</div>
		<div class="zk-w-full xl:zk-w-6/12 xl:zk-pl-2">
			<zk-input
				class="sm:zk-mt-1"
				[zkStatus]="
					isFieldInvalid(formParams, 'addressNumber') ? 'error' : 'default'
				"
			>
				<input
					id="billing-address-number"
					zkInputRef
					formControlName="addressNumber"
					class="md:zk-pr-0"
					placeholder="{{ getLabelDescription('address_number') }}"
				/>
				<span zkInputLabel>{{ getLabelDescription('address_number') }} </span>
				<span
					zkInputMessage
					[class.zk-hidden]="!isFieldInvalid(formParams, 'addressNumber')"
				>
					{{
						'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.ADDRESS_NUMBER'
							| translate
					}}
				</span>
			</zk-input>
		</div>
	</div>

	<div class="zk-w-full">
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="isFieldInvalid(formParams, 'address') ? 'error' : 'default'"
		>
			<input
				id="billing-address"
				zkInputRef
				formControlName="address"
				placeholder="{{ getLabelDescription('address') }}"
			/>
			<span zkInputLabel>{{ getLabelDescription('address') }} </span>
			<span
				zkInputMessage
				[class.zk-hidden]="!isFieldInvalid(formParams, 'address')"
			>
				{{ 'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.ADDRESS' | translate }}
			</span>
		</zk-input>
	</div>

	<div class="zk-w-full">
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="
				isFieldInvalid(formParams, 'neighborhood') ? 'error' : 'default'
			"
		>
			<input
				id="billing-neighborhood"
				zkInputRef
				formControlName="neighborhood"
				placeholder="{{ getLabelDescription('neighborhood') }}"
			/>
			<span zkInputLabel>{{ getLabelDescription('neighborhood') }} </span>
			<span
				zkInputMessage
				[class.zk-hidden]="!isFieldInvalid(formParams, 'neighborhood')"
			>
				{{
					'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.NEIGHBORHOOD' | translate
				}}
			</span>
		</zk-input>
	</div>

	<div class="zk-w-full">
		<zk-input class="sm:zk-mt-1" [zkStatus]="'default'">
			<input
				id="billing-address-complement"
				zkInputRef
				formControlName="addressComplement"
				placeholder="{{
					'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ADDRESS_COMPLEMENT' | translate
				}}"
			/>
			<span zkInputLabel
				>{{
					'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ADDRESS_COMPLEMENT' | translate
				}}
			</span>
		</zk-input>
	</div>

	<div class="zk-w-full">
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="isFieldInvalid(formParams, 'city') ? 'error' : 'default'"
		>
			<input
				id="billing-city"
				zkInputRef
				formControlName="city"
				placeholder="{{ getLabelDescription('city') }}"
			/>
			<span zkInputLabel>{{ getLabelDescription('city') }} </span>
			<span
				zkInputMessage
				[class.zk-hidden]="!isFieldInvalid(formParams, 'city')"
			>
				{{ 'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.CITY' | translate }}
			</span>
		</zk-input>
	</div>

	<div class="zk-w-full" *ngIf="!formParams.get('liveOutsideBrazil')?.value">
		<zk-dropdown
			formControlName="state"
			[disabled]="formParams.get('state')?.disabled"
			[label]="getLabelDescription('state')"
			[options]="states"
			[zkStatus]="isFieldInvalid(formParams, 'state') ? 'error' : 'default'"
		></zk-dropdown>
	</div>

	<div class="zk-w-full" *ngIf="formParams.get('liveOutsideBrazil')?.value">
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="isFieldInvalid(formParams, 'state') ? 'error' : 'default'"
		>
			<input
				id="billing-state"
				zkInputRef
				formControlName="state"
				placeholder="{{ getLabelDescription('state') }}"
			/>
			<span zkInputLabel>{{ getLabelDescription('state') }} </span>
			<span
				zkInputMessage
				[class.zk-hidden]="!isFieldInvalid(formParams, 'state')"
			>
				{{ 'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.STATE' | translate }}
			</span>
		</zk-input>
	</div>

	<div class="zk-w-full" *ngIf="formParams.get('liveOutsideBrazil')?.value">
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="
				isFieldInvalid(formParams, 'addressCountry') ? 'error' : 'default'
			"
		>
			<input
				id="billing-address-country"
				zkInputRef
				formControlName="addressCountry"
				placeholder="{{
					'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ADDRESS_COUNTRY' | translate
				}}"
			/>
			<span zkInputLabel
				>{{
					'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ADDRESS_COUNTRY' | translate
				}}
			</span>
			<span
				zkInputMessage
				[class.zk-hidden]="!isFieldInvalid(formParams, 'addressCountry')"
			>
				{{
					'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.ADDRESS_COUNTRY'
						| translate
				}}
			</span>
		</zk-input>
	</div>
</div>
